<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  name: 'App'
}
</script>


<style lang="scss">
#app {
  height: 100vh;
  width: 100vw;
}

</style>
